import { Button } from "./Button";
import { Input } from "./Input";
import { Text } from "./Text";

export const components = {
	Button,
	Input,
	Text,
};
